type StandaloneNavigator = Navigator & { standalone?: boolean };

export function isRunningStandalonePwa(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const mediaQueryList = typeof window.matchMedia === 'function'
    ? window.matchMedia('(display-mode: standalone)')
    : undefined;
  const isStandaloneDisplay = mediaQueryList?.matches ?? false;
  const isIosStandalone = (window.navigator as StandaloneNavigator).standalone === true;
  const isLaunchedFromApp = typeof document !== 'undefined' && document.referrer.startsWith('android-app://');

  return Boolean(isStandaloneDisplay || isIosStandalone || isLaunchedFromApp);
}
